export const ACTION_SAVE_COMPANY_PROFILE = 'save_company_profile'
export const ACTION_SAVE_INVOICE_TERMS = 'save_invoice_terms'
export const ACTION_SAVE_CREDIT_INFO = 'save_credit_info'
export const ACTION_SAVE_KYC_INFO = 'save_kyc_info'
export const ACTION_SAVE_USER_PASSWORD = 'save_user_password'
export const ACTION_SAVE_COMPANY_TEAM = 'save_company_team'
export const ACTION_SAVE_CATALOG_INFO = 'save_catalog_info'
